import client from "./client";

export interface EmailLogEntry {
  id: string;
  to_email: string;
  subject: string;
  template_key: string | null;
  backend: string | null;
  status: string; // sent | suppressed | failed
  error_message: string | null;
  sent_at: string;
}

export interface EmailLogPage {
  items: EmailLogEntry[];
  next_before: string | null;
  has_more: boolean;
}

export interface EmailLogFilters {
  status?: string;
  template_key?: string;
  to_email?: string;
  before?: string;
  limit?: number;
}

export async function listEmailLogs(
  filters: EmailLogFilters = {},
): Promise<EmailLogPage> {
  const { data } = await client.get<EmailLogPage>("/email-logs", {
    params: filters,
  });
  return data;
}
